<template>
  <div class="home">
    <div style="position: absolute;font-size: 0.3rem; bottom: 0.2rem; right: 0.4rem; z-index: 1000"><a href="https://beian.miit.gov.cn" target="_blank" style="color: #000;text-decoration: none">粤ICP备16100750号-3</a></div>
    <img alt="Vue logo" src="@/assets/img/homePage.jpg">
    <div class="home_render">
      <div class="info1">VISION INTELLIGENT SYSTEM UNION MALL</div>
      <div class="info2 font_shadow">专业让视界更健康</div>
      <div class="info3 font_shadow">患者首选眼健康服务平台</div>
      <button class="regBtn" @click="register" v-show="false">立即注册</button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {
  },
  methods: {
    register() {
      this.$router.push({path: '/Register'});
    }
  }
}
</script>

<style scoped lang="scss">
.home {
  width: 100vw;
  min-width: 1024px;
  position: relative;
  img {
    width: 100%;
  }
  .home_render {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(0, -50%);
    .info1 {
      font-size: 0.34rem;
      font-weight: bold;
      margin-bottom: 0.18rem;
    }
    .info2 {
      letter-spacing: 0.05rem;
      font-size: 1.1rem;
      font-weight: 800;
      margin-bottom: 0.35rem;
    }
    .info3 {
      font-size: 0.44rem;
      font-weight: 400;
      margin-bottom: 0.2rem;
    }
    .regBtn {
      padding: 0.12rem 0.28rem;
      border-radius: 0.1rem;
      font-size: 0.13rem;
      font-weight: 500;
      color: #FFFFFF;
      border: 1px solid #FFA800;
      background: #FFA800;
    }
  }
}
</style>
